export default __webpack_public_path__ + "static/media/armature.feb9a2cf.jpg";